<template>
  <div id="candidatos-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <destruccion-data
                      :idNivel="idNivel"
                      :tipoPrueba="tipoPrueba"
                      :tipeView="tipeView"
                    ></destruccion-data>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DestruccionData from "@/modules/captura/views/destruccion/DestruccionData.vue";

import axios from "axios";

export default {
  name: "destruccion-registra",
  components: {
    DestruccionData,
  },
  props: {},

  data: () => ({
    documentoId: "",
    id: "",
    tipeView: "",
    idNivel: "",
    tipoPrueba: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.idNivel = this.$route.params.idNivel;
    this.tipoPrueba = this.$route.params.tipoPrueba;
    this.tipeView = this.$route.params.tipeView;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
